import { useRouter } from 'src/hooks/useRouter';
import DateStamp from 'src/components/atoms/DateStamp';
import BoxTitle from 'src/components/atoms/BoxTitle';
import FilledImage from 'src/components/molecules/FilledImage';
import EventDetailsList from 'src/components/molecules/EventDetailsList';
import { FaRegCalendar, FaMapMarkerAlt } from 'react-icons/fa';
import { ImTicket } from 'react-icons/im';
import EventCardTags from 'src/components/molecules/EventCardTags';
import Link from 'src/components/atoms/Link';
import EventLink from '../../atoms/EventLink';

const BasicListItem = ({ event, extraClasses, itemRef }) => {
  const router = useRouter();

  return (
    <div
      className={`c-card relative block border-gray-200 overflow-hidden bg-white subtle-shadow ${extraClasses}`}
      ref={itemRef}
    >
      <EventLink key={event.id} href={event.href} event={event}>
        <div className="flex flex-col h-full">
          <div className="flex-grow">
            <div className="flex flex-row mt-3">
              <DateStamp event={event} />
              <div className="inline-block mx-2">
                <BoxTitle title={event.title} />
              </div>
            </div>
            <EventDetailsList event={event} />
          </div>

          <EventCardTags event={event} />
        </div>
      </EventLink>
    </div>
  );
};

export default BasicListItem;
